import { NodeEntry } from 'slate';

import chipHandlers from './chipHandlers';
import cleanupHandlers from './cleanupHandlers';
import groupHandlers from './groupHandlers';
import operatorHandlers from './operatorHandlers';
import simpleChipHandlers from './simpleChipHandlers';
import { createNormalizationState } from './utils';

/**
 * Plugin to handle automatic conversion of text to structured nodes
 */
// [PURPOSE]: Defines a Slate plugin that enhances the editor with custom normalization rules for automatically converting text patterns into structured elements like chips, logical operators, and groups.
export const withQueryNodes = (editor: any) => {
  const { normalizeNode: originalNormalizeNode } = editor;

  const normalizationState = createNormalizationState();

  /**
   * Normalization handlers map - each handler encapsulates one transformation
   */
  const normalizationHandlers = {
    ...cleanupHandlers,
    ...chipHandlers,
    ...groupHandlers,
    ...operatorHandlers,
    ...simpleChipHandlers,
  };

  // [PURPOSE]: Overrides Slate's default 'normalizeNode' method. It iterates through the defined 'normalizationHandlers' for each node entry, applying the first matching handler. It includes loop detection to prevent infinite normalization cycles. If no custom handler applies, it falls back to the original 'normalizeNode'.
  editor.normalizeNode = (entry: NodeEntry) => {
    const [node, path] = entry;
    const pathKey = path.join(',');

    // Loop detection
    const count = (Number(normalizationState.counts.get(pathKey)) || 0) + 1;
    normalizationState.counts.set(pathKey, count);

    // Try each handler in sequence
    for (const handlerName of Object.keys(normalizationHandlers)) {
      try {
        const handler = (normalizationHandlers as any)[handlerName];
        const result = handler(editor, node, path);

        if (result) {
          return; // Handler succeeded, don't continue
        }
      } catch {
        // Allow to fail silently
      }
    }

    // Fall back to original normalizeNode for other cases
    return originalNormalizeNode(entry);
  };

  return editor;
};
